import React from 'react';

import './SignupProgress.scss';

const SignupProgress = ({ currentStep, totalSteps }) => {
  const percent = Math.max(0, Math.min(100, (currentStep / totalSteps) * 100));
  return (
    <div
      className="SignupProgress"
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-label={`Step ${currentStep} of ${totalSteps}`}
    >
      <div className="SignupProgress__label">
        Step {currentStep} of {totalSteps}
      </div>
      <div className="SignupProgress__track">
        <div className="SignupProgress__fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default SignupProgress;
